import { useParams } from 'react-router-dom'
import { useSubscription } from '@apollo/client'
import { notification } from 'antd'
import { isEmpty } from 'lodash'

import { UNBLOCK_MENU_CURATION_TASK_SUBSCRIPTION } from '../graphql/subscriptions'

const useUnblockMenuCurationTaskSubscription = refetchMenuCurationTask => {
  const { id } = useParams()

  useSubscription(UNBLOCK_MENU_CURATION_TASK_SUBSCRIPTION, {
    onSubscriptionData: ({ subscriptionData: { data } }) => {
      if (isEmpty(data)) {
        return null
      }

      const { unblockMenuCurationTask } = data

      if (id === unblockMenuCurationTask?.menuCurationTaskId) {
        const notificationKey = `open${Date.now()}`

        refetchMenuCurationTask(id)

        if (unblockMenuCurationTask?.isUnblockWithError) {
          return notification.warning({
            key: notificationKey,
            message: 'AI suggestions finished with errors',
            description: `Task unblocked with errors:
              ${unblockMenuCurationTask?.reason}`,
            placement: 'topLeft',
          })
        }

        return notification.success({
          key: notificationKey,
          message: 'AI suggestions finished',
          description: `Task unblocked successfully`,
          placement: 'topLeft',
        })
      }

      return null
    },
  })
}

export default useUnblockMenuCurationTaskSubscription
